module.exports = __webpack_public_path__ + "img/appstore.84ab2769.svg";